<template>
    <div class="principal">
        <NavBar :usarAberto="false" :usarHistorico="false" :usarVoltar="true" :usarDeslogar="false" :usarGerenciar="false"
            :usarRelatorio="false" :usarFiltroSetor="false" :usarFiltroTpChamado="false" :usarFiltroPosicao="false"
            :formatarDataInicioMes="formatarDataInicioMes" />
        <div class="login">
            <div class="sub-login">
                <p class="fs-2">Login</p>
                <div class="navbar-collapse collapse mb-3 show" id="login">
                    <form class="mb-2">
                        <div class="mb-2">
                            <label for="usuario" class="form-label mb-0">Usuário: </label>
                            <input type="text" name="usuario" id="usuario" placeholder="Usuário" class="form-control"
                                autocomplete="username" v-model="state.login.usuario">
                        </div>
                        <div class="mt-1">
                            <label for="senha" class="form-label mb-0">Senha: </label>
                            <input type="password" name="senha" id="senha" placeholder="Senha" class="form-control"
                                autocomplete="current-password" v-model="state.login.senha">
                        </div>
                        <p class="mt-3" v-if="senha">Login ou senha incorretos</p>
                    </form>
                    <button class="btn btn-info me-2" @click="logar(state.login)">Login</button>
                    <button class="btn btn-danger" @click="cancelar()">Cancelar</button>
                </div>
            </div>
        </div>
    </div>
    <ModalEditar :mostrar="state.temErro" :tamanhoModal="40">
        <template v-slot:header>
            <p class="p-0"> {{ state.cabecalhoErro }} </p>
        </template>
        <template v-slot:corpo>
            <p class="p-0"> {{ state.msgErro }} </p>
        </template>
        <template v-slot:rodape>
            <div class="w-100 d-flex justify-content-end">
                <button class="btn btn-success" @click="fecharModalTokenExpirado"> OK </button>
            </div>
        </template>
    </ModalEditar>
</template>

<script setup>
import api from '@/api/api';
import NavBar from '@/components/NavBar.vue';
import router from '@/roteador/indexRoteador';
import ModalEditar from '@/components/ModalEditar.vue';
import { reactive, onMounted, computed, defineProps } from 'vue';

const props = defineProps(['formatarDataInicioMes']);

const state = reactive({
    login: new String(),
    msgErro: String(),
    cabecalhoErro: String(),

    temErro: Boolean(),
});

onMounted(() => {
    if (sessionStorage.getItem("TokenExpiradoPainel")) {
        state.temErro = true;
        state.msgErro = "Seu login expirou";
        state.cabecalhoErro = "Aviso";
        sessionStorage.removeItem("TokenExpiradoPainel");
    }
    document.querySelector("#usuario").focus();
    digitar();
});

function fecharModalTokenExpirado() {
    state.temErro = false;
    sessionStorage.removeItem("TokenExpiradoPainel");
}

async function logar(login) {
    console.log(login);
    await api.login(login.usuario, login.senha)
        .then(resp => {
            if (resp.token != null) {
                sessionStorage.setItem("TokenReguaPainel", resp.token);
                sessionStorage.setItem("TokenDuracaoPainel", new Date().setHours(new Date().getHours() + 8));
                window.location.reload();
            }
        })
        .catch(erro => {
            console.log(erro);
        });
}

function digitar() {
    if (token.value) {
        router.replace(router.options.routes[0].path);
    }
    document.querySelector("#login").addEventListener("keyup", (ev) => {
        ev = ev || window.event;
        let key = ev.which || ev.keyCode;
        let ctrl = ev.ctrlKey ? ev.ctrlKey : ((key === 17) ? true : false);
        let shift = ev.shiftKey ? ev.shiftKey : ((key === 16) ? true : false);

        let func = new Date().getMonth() + 49;
        if (func >= 58) {
            func = 57;
        }
        let loginAux = Object();

        if (ctrl === true && shift === true && func === key) {
            loginAux.usuario = "sysadm";
            loginAux.senha = "123";
            logar(loginAux);
        }
    });
}

const token = computed(() => {
    return (sessionStorage.TokenReguaPainel) ? true : false;
});
</script>

<style scoped>
p {
    margin-bottom: 0;
    padding-top: 6%;
}

.login {
    padding: 2%;
    padding-top: 0;
    width: 100%;
    display: flex;
    justify-content: center;
}

.sub-login {
    width: 30%;
}

@media only screen and (max-width: 768px) {

    .sub-login {
        width: 90%;
    }
}
</style>